module.exports = __webpack_public_path__ + "img/sizes.f046bfe7.jpg";